import makeAuthApi from '@counsel-project/counsel-auth-api'
import { url } from './url'
import errorHandler from './errorHandler'

export const authRequest = makeAuthApi({
  url: url + '/auth',
  key: '',
  withCredentials: true,
  errorHandler,
})
